export enum PoolTransactionsTab {
  ALL_ACTIVITY = 'allActivity',
  ABOUT_THIS_POOL = 'aboutThisPool',
  USER_ACTIVITY = 'userActivity',
  SWAPS = 'swaps'
}
